const state={
  products:[],
  thingModels:[],
  devices:[]
}

const actions={
  setProducts({commit}:any,res:any){
    commit('setProducts',res)
  },
  setThingModels({commit}:any,res:any){


    commit('setThingModels',res)
  },
  setDevices({commit}:any,res:any){

    commit('setDevices',res)
  }
}

const getters={
  Products:(state:any)=>{
    if (state.products&&state.products.length>0){
      return state.products;
    }else{
      if (localStorage.getItem('products')){
        return JSON.parse(localStorage.getItem('products'))
      }else{
        return [];
      }

    }

  },
  ThingModels:(state:any)=>{
    if (state.thingModels&&state.thingModels.length>0){
      return state.thingModels;
    }else{
      if (localStorage.getItem('thingModels')){
        return JSON.parse(localStorage.getItem('thingModels'))
      }else{
        return [];
      }
    }
  },
  Devices:(state:any)=>{
    if (state.devices&&state.devices.length>0){

      return state.devices;
    }else{
      if (localStorage.getItem('devices')){
        return JSON.parse(localStorage.getItem('devices'))
      }else{
        return [];
      }



    }
  }
}

const mutations= {
  setProducts(state:any,res:any){
    state.products=res
    localStorage.setItem('products',JSON.stringify(res) )
  },
  setThingModels(state:any,res:any){
    state.thingModels=res
    localStorage.setItem('thingModels', JSON.stringify(res))
  },
  setDevices(state:any,res:any){
    console.log('res',JSON.stringify(res));
    state.devices=res
    localStorage.setItem('devices', JSON.stringify(res))
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
